<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Nova Movimentação Financeira
        </span>
      </h3>
    </div>
    <Form url="/financeiro/create" :financeiro="financeiro" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import FinanceiroData from "./FinanceiroData";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "app-financeiro-create",
  data() {
    return {
      financeiro: new FinanceiroData({
        data: moment().format("YYYY-MM-DD"),
      }),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.financeiro.data = moment().format("YYYY-MM-DD");
  },
};
</script>
